import { render } from "./international-accreditation.vue?vue&type=template&id=945e1fce&scoped=true"
import script from "./international-accreditation.vue?vue&type=script&lang=js"
export * from "./international-accreditation.vue?vue&type=script&lang=js"

import "./international-accreditation.vue?vue&type=style&index=0&id=945e1fce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-945e1fce"

export default script